<template>
  <div class="sf-el number-input">
    <div class="sf-number">
      <label class="sf-el__label">
        {{ label }}
        <span v-if="required" class="sf-el__required">*</span>
      </label>
      <p v-if="caption" class="sf-el__caption">{{ caption }}</p>
      <input type="number" v-model="value" :placeholder="label" :min="min" :max="max" />
    </div>
  </div>
</template>

<script>
  import { watch, ref } from 'vue';

  export default {
    name: 'NumberElement',
    props: {
      label: String,
      description: String,
      caption: String,
      name: String,
      modelValue: Number,
      min: {
        type: Number,
        default: 0,
      },
      max: {
        type: Number,
        default: 100,
      },
      step: {
        type: Number,
        default: 1,
      },
      required: Boolean,
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
      const value = ref(props.modelValue);
      watch(value, (newValue) => {
        emit('update:modelValue', newValue);
      });
      return {
        value,
      };
    },
  };
</script>

<style scoped lang="scss">
  .sf-number {
    &__wrap {
      display: flex;
      gap: 24px;
      input[type='number'] {
        max-width: 30%;
        width: 150px;
      }
    }
    &__range {
      display: flex;
      gap: 8px;
      align-items: center;
      flex-grow: 1;
    }
  }
</style>
